<template>
	<div id="app" :class="{'grey-filter' : greyTheme}">
		<router-view />
	</div>
</template>

<script>
	import api from './http/common'
	export default {
		name: "App",
		data(){
			return{
				greyTheme : false
			}
		},
		methods:{
			getTheme(){
				api.getTheme().then(res => {
					if(res == "grey"){
						this.greyTheme = true;
						console.log(this.greyTheme)
					}
				})
			}
		},
		mounted() {
			if(this.$route.path != '/noFilter'){
				this.getTheme()
			}
		}
	};
</script>

<style>
	.grey-filter{
		    filter: grayscale(100%);
		    -webkit-filter: grayscale(100%);
		    -moz-filter: grayscale(100%);
		    -ms-filter: grayscale(100%);
		    -o-filter: grayscale(100%);
		    filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
		    -webkit-filter: grayscale(1);
	}
	* {
		margin: 0;
		padding: 0;
	}

	html,
	body {
		width: 100%;
		height: 100%;
	}

	#app {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin: 0;
		padding: 0;
		width: 100%;
		height: 100%;
		overflow-x: hidden;
	}

	.iconfont {
		margin-right: 7px;
	}

	.flex {
		display: flex;
	}

	.flex-center {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	a {
		color: #333333;
		text-decoration: none;
	}

	a:visited {
		/* color: #FFFFFF; */
	}

	.text-left {
		text-align: left;
	}

	.full-height {
		height: 100%;
	}

	.full-width{
		width: 100%;
	}
	
	.full-parent{
		width: 100%;
		height: 100%;
	}

	.hand-cursor {
		cursor: pointer;
	}
	.text-overflow-hidden{
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.el-pagination.is-background .el-pager li:not(.disabled).active {
	  background-color: #A10000;
	}
	.list-item-divider{
		width: 100%;
		border: 1px dashed #DDDDDD;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue